import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ServiceMappingGridReturnModel, ServiceMappingToMasterGridResult, ServiceMasterExpandedReturnModel } from '../shared';
import { Constants } from '../shared/constants';
import { HeaderFilterData, UnifiedTransactionsForServiceAndProductMappingReturn } from '../shared/models/product.model';
import { HeaderFilterOption, LoadOptions } from '../shared/models/shared.model';

@Injectable({
  providedIn: 'root'
})
export class ServiceMasterMappingApi {
  private token = localStorage.getItem('token');
  private headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + this.token });

  private url = Constants.devServerEndpoint + 'api/serviceMasterMapping';

  constructor(private httpClient: HttpClient) { }

  public getServiceMappingGrid(param: LoadOptions): Observable<ServiceMappingGridReturnModel[]> {
	return this.httpClient
		.post<ServiceMappingGridReturnModel[]>(
		this.url + `/getServiceMappingGrid`, param,
		{ headers: this.headers }
		);
  }

  public getUnifiedTransactionsForServiceAndProductMapping(param: LoadOptions, serviceAndProductMappingId: number): Observable<UnifiedTransactionsForServiceAndProductMappingReturn[]> {
	return this.httpClient
		.post<UnifiedTransactionsForServiceAndProductMappingReturn[]>(
		this.url + `/getUnifiedTransactionsForServiceAndProductMapping/${serviceAndProductMappingId}`, {param, serviceAndProductMappingId},
		{ headers: this.headers }
		);
  }

  public getServiceMappingToMasterGrid(serviceAndProductMappingId: number): Observable<ServiceMappingToMasterGridResult[]> {
	return this.httpClient.get<ServiceMappingToMasterGridResult[]>(this.url + `/getServiceMappingToMasterGrid/${serviceAndProductMappingId}`, { headers: this.headers });
  }

  public getServiceMasterExpanded(param: LoadOptions): Observable<ServiceMasterExpandedReturnModel> {
	return this.httpClient
		.post<ServiceMasterExpandedReturnModel>(
		this.url + `/getServiceMasterExpanded`, param,
		{ headers: this.headers }
		);
  }

  public getHeaderFiltersServiceMaster(param: HeaderFilterOption): Observable<HeaderFilterData[]> {
	return this.httpClient
		.post<HeaderFilterData[]>(
			this.url + `/getHeaderFiltersServiceMaster`, param,
			{ headers: this.headers }
		);
}

public getHeaderFiltersServiceMapping(param: HeaderFilterOption): Observable<HeaderFilterData[]> {
	return this.httpClient
		.post<HeaderFilterData[]>(
			this.url + `/getHeaderFiltersServiceMapping`, param,
			{ headers: this.headers }
		);
}

  public mappingAction(productMappingOption): Observable<any> {
	return this.httpClient
		.post<any>(
			this.url + '/mappingAction', productMappingOption,
			{ headers: this.headers }
		);
  }
}
